import { Contact } from "components/Contact";
import { CoursesListWrapper } from "components/CoursesList";
import { EXTRALARGE, WHITE } from "shared/variables";
import { Intro } from "components/Intro";
import { MaxWidth } from "components/MaxWidth";
import { OverlapArea } from "components/OverlapArea";
import { Page } from "components/Page";
import { RichText } from "components/slices/RichText";
import { SpacingSection } from "components/SpacingSection";

export const CourseTrainingOverviewPage = ({ doc, items, preview, title }) => {
  const {
    seo_title,
    seo_description,
    seo_image,
    intro,
    rich_text,
    contact_title,
    contact_email,
    contact_tel,
    contact_whatsapp,
  } = doc.data;

  const renderContact =
    contact_title || contact_email || contact_tel || contact_whatsapp;

  return (
    <Page
      description={seo_description}
      image={seo_image}
      preview={preview}
      title={seo_title}
      withLightFooter
    >
      <OverlapArea>
        <MaxWidth>
          <Intro color={WHITE} title={title} text={intro} />
        </MaxWidth>
      </OverlapArea>
      <MaxWidth size={EXTRALARGE}>
        <CoursesListWrapper courses={items} />
      </MaxWidth>
      <SpacingSection size={EXTRALARGE}>
        <MaxWidth>{rich_text && <RichText content={rich_text} />}</MaxWidth>
      </SpacingSection>
      {renderContact && (
        <Contact
          title={contact_title}
          email={contact_email}
          tel={contact_tel}
          whatsapp={contact_whatsapp}
        />
      )}
    </Page>
  );
};
